import { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom"
import DoctorCard from "../components/DoctorCard"
import SEO from './SEO';

const schema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "MAMS Hospitals",
    "url": "https://mamshospitals.com",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "description": "MAMS Hospitals - A legacy of healing, compassion, and excellence in healthcare since 1992.",
    "foundingDate": "1996",
    "founder": {
      "@type": "Person",
      "name": "Sri Puvvada Nageswara Rao"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally, Hyderabad, Telangana – 500090",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+91-7399999981",
        "email": "contact@mamshospitals.com",
        "availableLanguage": ["English", "Hindi", "Telugu"]
      }
    ],
    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },


  {
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mamshospitals.com/doctors"
  },
  "headline": "Meet Our Doctors at MAMS Hospitals",
  "description": "Our team of highly qualified healthcare professionals is committed to providing exceptional care with expertise and compassion across specialties such as cardiology, neurosurgery, pediatrics, orthopedics, dermatology, general surgery, and more.",
  "author": {
    "@type": "Organization",
    "name": "MAMS Hospitals"
  },
  "publisher": {
    "@type": "Organization",
    "name": "MAMS Hospitals",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mamshospitals.com/MAMS-Logo.png"
    }
  },
  "datePublished": "2025-09-10",
  "dateModified": "2025-09-10",
  "articleSection": [
    "Doctors",
    "Specialties",
    "Medical Experts"
  ],
  "mainEntity": {
    "@type": "ItemList",
    "name": "List of Doctors at MAMS Hospitals",
    "itemListElement": [
      //Orthopedics
    {
      "@type": "Physician",
      "name": "Dr Sriramozu Srikanth",
      "medicalSpecialty": "Orthopedics",
      "description": "Specializes in joint replacements and sports medicine with advanced surgical techniques.",
      "image": "https://mamshospitals.com/images/1 Dr Sriramozu Srikanth.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Sujit Kumar Vakati",
      "medicalSpecialty": "Orthopedics",
      "description": "Expert in orthopedics with focus on trauma, joint replacements, and arthroscopic surgery.",
      "image": "https://mamshospitals.com/images/Dr. Sujit Kumar, Prof, Ortho.JPG",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr M Sreenath",
      "medicalSpecialty": "Orthopedics",
      "description": "Specializes in orthopedic trauma, arthroscopy, and joint replacement.",
      "image": "https://mamshospitals.com/images/3 Dr M Sreenath.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Vajrala Sahetya Mohan Rao",
      "medicalSpecialty": "Orthopedics",
      "description": "Focuses on complex orthopedic surgeries and sports medicine.",
      "image": "https://mamshospitals.com/images/4 Dr Vajrala Sahetya Mohan Rao.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Macharla Vikram Goud",
      "medicalSpecialty": "Orthopedics",
      "description": "Orthopedic surgeon specializing in trauma, arthroscopy, and sports injuries.",
      "image": "https://mamshospitals.com/images/5 Dr Macharla Vikram Goud.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Kalidindi Vamsi Krishna Varma",
      "medicalSpecialty": "Orthopedics",
      "description": "Specialist in minimally invasive orthopedic surgery and joint care.",
      "image": "https://mamshospitals.com/images/6 Dr Kalidindi Vamsi Krishna Varma.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Gorla Vijay Kumar Reddy",
      "medicalSpecialty": "Orthopedics",
      "description": "Expert in orthopedic trauma and advanced bone reconstruction.",
      "image": "https://mamshospitals.com/images/7 Dr Gorla Vijay Kumar Reddy.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
  

    {
      "@type": "Physician",
      "name": "Dr Gutta Harikrishna",
      "medicalSpecialty": "Orthopedics",
      "description": "Specialist in bone fracture management and joint surgeries.",
      "image": "https://mamshospitals.com/images/10 Dr Gutta Harikrishna.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Kottapally Sree Kalyani",
      "medicalSpecialty": "Orthopedics",
      "description": "Expert in orthopedic trauma and rehabilitation.",
      "image": "https://mamshospitals.com/images/11 Dr Kottapally Sree Kalyani.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },

    /* ENT */
    {
      "@type": "Physician",
      "name": "Dr Ahmed Abdul Majid Hussaini",
      "medicalSpecialty": "ENT",
      "description": "Specialist in ENT with focus on surgical and non-surgical treatments.",
      "image": "https://mamshospitals.com/images/1 Dr Ahmed Abdul Majid Hussaini.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Uma Pokala",
      "medicalSpecialty": "ENT",
      "description": "Specialist in ENT disorders including ear and sinus surgeries.",
      "image": "https://mamshospitals.com/images/2 Dr Uma Pokala.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Maryada Sravani",
      "medicalSpecialty": "ENT",
      "description": "Expert in ENT care and advanced surgical interventions.",
      "image": "https://mamshospitals.com/images/Dr Maryada Sravani.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Sivapuram Kavya",
      "medicalSpecialty": "ENT",
      "description": "Specializes in ENT disorders with focus on surgical care.",
      "image": "https://mamshospitals.com/images/3 Dr Sivapuram Kavya.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Pasunooti Shravya",
      "medicalSpecialty": "ENT",
      "description": "Expert in ENT care and minimally invasive treatments.",
      "image": "https://mamshospitals.com/images/Dr Pasunooti Shravya.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Surabhi Periwal",
      "medicalSpecialty": "ENT",
      "description": "Specialist in ENT with expertise in nasal and sinus disorders.",
      "image": "https://mamshospitals.com/images/4 Dr Surabhi Periwal.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
 
    
 
    // //Neurosurgery
    {
      "@type": "Physician",
      "name": "Dr. Anusha",
      "medicalSpecialty": "Neurosurgery",
      "description": "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      "image": "https://mamshospitals.com/images/DR.ANUSHA.JPG",
      "memberOf": {
        "@type": "Hospital",
        "name": "MAMS Hospitals",
        "url": "https://mamshospitals.com/"
      },
    },
    {
      "@type": "Physician",
      "name": "Dr. Rithvic",
      "medicalSpecialty": "Neurosurgery",
      "description": "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      "image": "https://mamshospitals.com/images/DR. RITHVIC.JPG",
      "memberOf": {
        "@type": "Hospital",
        "name": "MAMS Hospitals",
        "url": "https://mamshospitals.com/"
      },
    },
   
    {
      "@type": "Physician",
      "name": "Dr. Swapnil Kolpakwar",
      "medicalSpecialty": "Neurosurgery",
      "description": "Renowned neurosurgeon with expertise in complex brain surgeries and spine disorders.",
      "image": "https://mamshospitals.com/images/Dr Swapnil Kolpakwar.png",
      "memberOf": {
        "@type": "Hospital",
        "name": "MAMS Hospitals",
        "url": "https://mamshospitals.com/"
      },
    },
    //Neurology
    {
      "@type": "Physician",
      "name": "Dr. Gajula Sai Krishna",
      "medicalSpecialty": "Neurology",
      "description": "Specialist in diagnosing and treating neurological conditions, including stroke, epilepsy, and movement disorders.",
      "image": "https://mamshospitals.com/images/Dr. Gajula Sai Krishna.png",
      "memberOf": {
        "@type": "Hospital",
        "name": "MAMS Hospitals",
        "url": "https://mamshospitals.com/"
      }
    },
    {
      "@type": "Physician",
      "name": "Dr. Gireesh",
      "medicalSpecialty": "Neurology",
      "description": "Expert neurologist providing comprehensive care for disorders of the brain and nervous system.",
      "image": "https://mamshospitals.com/images/Dr.Gireesh.png",
      "memberOf": {
        "@type": "Hospital",
        "name": "MAMS Hospitals",
        "url": "https://mamshospitals.com/"
      }
    },
    //Nephrology
    {
  "@context": "https://schema.org",
  "@type": "Physician",
  "name": "Dr. Bhavya Dasara",
  "medicalSpecialty": "Nephrology",
  "description": "Kidney specialist with extensive experience in treating complex renal conditions, including dialysis and transplantation support.",
  "image": "https://mamshospitals.com/images/DR.BHAVYA%20DASARA.JPG",
  "memberOf": {
    "@type": "Hospital",
    "name": "MAMS Hospitals",
    "url": "https://mamshospitals.com/"
  }
},
//Gastroenterology
{
  "@context": "https://schema.org",
  "@type": "Physician",
  "name": "Dr. Kapil Tejaswy",
  "medicalSpecialty": "Gastroenterology",
  "description": "Expert in digestive disorders with advanced endoscopic and therapeutic skills.",
  "image": "https://mamshospitals.com/images/DR.KAPIL%20TEJASWY.JPG",
  "memberOf": {
    "@type": "Hospital",
    "name": "MAMS Hospitals",
    "url": "https://mamshospitals.com/"
  }
},
//Endocrinology
{
  "@context": "https://schema.org",
  "@type": "Physician",
  "name": "Dr. Gautham",
  "medicalSpecialty": "Endocrinology",
  "description": "Specializes in hormonal disorders and diabetes management with a holistic approach.",
  "image": "https://mamshospitals.com/images/Dr.%20Gautham.JPG",
  "memberOf": {
    "@type": "Hospital",
    "name": "MAMS Hospitals",
    "url": "https://mamshospitals.com/"
  }
},
//Psychiatry
{
      "@type": "Physician",
      "name": "Dr. Koneru Kavya Sri",
      "medicalSpecialty": "Psychiatry",
      "description": "Comprehensive mental health care for emotional, behavioral, and psychological well-being.",
      "image": "https://mamshospitals.com/images/1%20Dr%20Koneru%20Kavya%20Sri.jpg",
      "memberOf": {
        "@type": "Hospital",
        "name": "MAMS Hospitals",
        "url": "https://mamshospitals.com/"
      }
    },
    {
      "@type": "Physician",
      "name": "Dr. Kavuturi Praveen Kumar",
      "medicalSpecialty": "Psychiatry",
      "description": "Comprehensive mental health care for emotional, behavioral, and psychological well-being.",
      "image": "https://mamshospitals.com/images/2%20Dr%20kavuturi%20praveen%20kumar.jpg",
      "memberOf": {
        "@type": "Hospital",
        "name": "MAMS Hospitals",
        "url": "https://mamshospitals.com/"
      }
    },
    {
      "@type": "Physician",
      "name": "Dr. Sadam Vineela",
      "medicalSpecialty": "Psychiatry",
      "description": "Comprehensive mental health care for emotional, behavioral, and psychological well-being.",
      "image": "https://mamshospitals.com/images/3%20Dr%20sadam%20vineela.jpg",
      "memberOf": {
        "@type": "Hospital",
        "name": "MAMS Hospitals",
        "url": "https://mamshospitals.com/"
      }
    },
    //Respiratory Medicine
    {
      "@type": "Physician",
      "name": "Dr. Kancharla Srinivas",
      "medicalSpecialty": "Respiratory Medicine",
      "description": "Specialist in treating respiratory and lung-related disorders.",
      "image": "https://mamshospitals.com/images/Dr.Kancharla%20Srinivas%20Pulmonologist.jpg",
      "memberOf": {
        "@type": "Hospital",
        "name": "MAMS Hospitals",
        "url": "https://mamshospitals.com/"
      }
    },
    {
      "@type": "Physician",
      "name": "Dr. Sk. Mohammad Ismail",
      "medicalSpecialty": "Respiratory Medicine",
      "description": "Expert in the management of pulmonary diseases and respiratory health.",
      "image": "https://mamshospitals.com/images/Dr%20Sk%20Mohammad%20Ismail%20Pulmonologist.jpg",
      "memberOf": {
        "@type": "Hospital",
        "name": "MAMS Hospitals",
        "url": "https://mamshospitals.com/"
      }
    },
    //Dermatology
    {
      "@type": "Physician",
      "name": "Dr Sandeep Kodali",
      "medicalSpecialty": "Dermatology",
      "description": "Expert in treating various skin conditions with the latest therapeutic approaches.",
      "image": "https://mamshospitals.com/images/1 Dr Sandeep Kodali.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Lakshminarayan Divya",
      "medicalSpecialty": "Dermatology",
      "description": "Expert in treating various skin conditions with the latest therapeutic approaches.",
      "image": "https://mamshospitals.com/images/2 Dr Lakshminarayan Divya.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Vodapalli Akshya Kumar",
      "medicalSpecialty": "Dermatology",
      "description": "Expert in treating various skin conditions with the latest therapeutic approaches.",
      "image": "https://mamshospitals.com/images/3 Dr Vodapalli Akshya Kumar.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Kolla Sri Harsha",
      "medicalSpecialty": "Dermatology",
      "description": "Expert in treating various skin conditions with the latest therapeutic approaches.",
      "image": "https://mamshospitals.com/images/4 Dr Kolla Sri Harsha.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr H N Meghana",
      "medicalSpecialty": "Dermatology",
      "description": "Expert in treating various skin conditions with the latest therapeutic approaches.",
      "image": "https://mamshospitals.com/images/5 Dr H N Meghana.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Mallireddy Sujitha",
      "medicalSpecialty": "Dermatology",
      "description": "Expert in treating various skin conditions with the latest therapeutic approaches.",
      "image": "https://mamshospitals.com/images/6 Dr Mallireddy Sujitha.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    //Psychiatry
    {
      "@type": "Physician",
      "name": "Dr Koneru Kavya Sri",
      "medicalSpecialty": "Psychiatry",
      "description": "Comprehensive mental health care for emotional, behavioral, and psychological well-being.",
      "image": "https://mamshospitals.com/images/1 Dr Koneru Kavya Sri.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Kavuturi Praveen Kumar",
      "medicalSpecialty": "Psychiatry",
      "description": "Comprehensive mental health care for emotional, behavioral, and psychological well-being.",
      "image": "https://mamshospitals.com/images/2 Dr kavuturi praveen kumar.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Sadam Vineela",
      "medicalSpecialty": "Psychiatry",
      "description": "Comprehensive mental health care for emotional, behavioral, and psychological well-being.",
      "image": "https://mamshospitals.com/images/3 Dr sadam vineela.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    //Respiratory Medicine
    {
      "@type": "Physician",
      "name": "Dr Badam Aruna Kumari",
      "medicalSpecialty": "Respiratory Medicine",
      "description": "Specialized care for lung and breathing disorders to improve respiratory health.",
      "image": "https://mamshospitals.com/images/1 Dr Badam Aruna Kumari.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Terli Venkata Rajiv",
      "medicalSpecialty": "Respiratory Medicine",
      "description": "Specialized care for lung and breathing disorders to improve respiratory health.",
      "image": "https://mamshospitals.com/images/2 Dr Terli Venkata Rajiv.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr A Lavanya",
      "medicalSpecialty": "Respiratory Medicine",
      "description": "Specialized care for lung and breathing disorders to improve respiratory health.",
      "image": "https://mamshospitals.com/images/3 Dr A Lavanya.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
  
    {
      "@type": "Physician",
      "name": "Dr Alekya",
      "medicalSpecialty": "Respiratory Medicine",
      "description": "Specialized care for lung and breathing disorders to improve respiratory health.",
      "image": "https://mamshospitals.com/images/Dr. Alekya.JPG",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    //Ophthalmology
    {
      "@type": "Physician",
      "name": "Dr Gayatri Chelluri",
      "medicalSpecialty": "Ophthalmology",
      "description": "Expert eye care for vision correction, diagnosis, and treatment of eye conditions.",
      "image": "https://mamshospitals.com/images/1 Dr. Gayatri Chelluri Ophthalmology.jpeg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr KMamata Chodhury",
      "medicalSpecialty": "Ophthalmology",
      "description": "Expert eye care for vision correction, diagnosis, and treatment of eye conditions.",
      "image": "https://mamshospitals.com/images/2 Dr. KMamata Chodhury Ophthalmology.jpeg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },

    {
      "@type": "Physician",
      "name": "Dr Aleti Rushetha Reddy",
      "medicalSpecialty": "Ophthalmology",
      "description": "Expert eye care for vision correction, diagnosis, and treatment of eye conditions.",
      "image": "https://mamshospitals.com/images/4 Dr Aleti Rushetha Reddy Ophthalmology.jpeg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Deepthi Bethavalli",
      "medicalSpecialty": "Ophthalmology",
      "description": "Expert eye care for vision correction, diagnosis, and treatment of eye conditions.",
      "image": "https://mamshospitals.com/images/5 Dr Deepthi Bethavalli Ophthalmology.jpeg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Sathineddi Venkata Sowmya",
      "medicalSpecialty": "Ophthalmology",
      "description": "Expert eye care for vision correction, diagnosis, and treatment of eye conditions.",
      "image": "https://mamshospitals.com/images/6 Dr. Sathineddi Venkata Sowmya Ophthalmology.jpeg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    //Gynacology
    {
      "@type": "Physician",
      "name": "Dr Chippa Sangeeta Gangaiya",
      "medicalSpecialty": "Gynacology",
      "description": "Expert care for women's health including reproductive, obstetric, and gynecological conditions.",
      "image": "https://mamshospitals.com/images/1 Dr chippa sangeeta gangaiya.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr K E Manga Reddy",
      "medicalSpecialty": "Gynacology",
      "description": "Expert care for women's health including reproductive, obstetric, and gynecological conditions.",
      "image": "https://mamshospitals.com/images/2 Dr K E Manga Reddy.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Maitri Kulakarni",
      "medicalSpecialty": "Gynacology",
      "description": "Expert care for women's health including reproductive, obstetric, and gynecological conditions.",
      "image": "https://mamshospitals.com/images/3 Dr Maitri Kulakarni.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr A Ramani",
      "medicalSpecialty": "Gynacology",
      "description": "Expert care for women's health including reproductive, obstetric, and gynecological conditions.",
      "image": "https://mamshospitals.com/images/4 Dr A Ramani.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Nibedita Maharana",
      "medicalSpecialty": "Gynacology",
      "description": "Expert care for women's health including reproductive, obstetric, and gynecological conditions.",
      "image": "https://mamshospitals.com/images/5 Dr Nibedita Maharana.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Sailaja Kanakamedala",
      "medicalSpecialty": "Gynacology",
      "description": "Expert care for women's health including reproductive, obstetric, and gynecological conditions.",
      "image": "https://mamshospitals.com/images/6 Dr Sailaja kanakamedala.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Twinkle Sara Shyam",
      "medicalSpecialty": "Gynacology",
      "description": "Expert care for women's health including reproductive, obstetric, and gynecological conditions.",
      "image": "https://mamshospitals.com/images/7 Dr Twinkle Sara Shyam.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr B Aamani",
      "medicalSpecialty": "Gynacology",
      "description": "Expert care for women's health including reproductive, obstetric, and gynecological conditions.",
      "image": "https://mamshospitals.com/images/8 Dr B Aamani.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Rasika Madapoosi Raj Kumar",
      "medicalSpecialty": "Gynacology",
      "description": "Expert care for women's health including reproductive, obstetric, and gynecological conditions.",
      "image": "https://mamshospitals.com/images/9 Dr Rasika Madapoosi Raj Kumar.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Vishnu Priya Kokkula",
      "medicalSpecialty": "Gynacology",
      "description": "Expert care for women's health including reproductive, obstetric, and gynecological conditions.",
      "image": "https://mamshospitals.com/images/10 Dr Vishnu Priya Kokkula.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Kingam Sushma",
      "medicalSpecialty": "Gynacology",
      "description": "Expert care for women's health including reproductive, obstetric, and gynecological conditions.",
      "image": "https://mamshospitals.com/images/11 Dr Kingam Sushma.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Mallu Srinija",
      "medicalSpecialty": "Gynacology",
      "description": "Expert care for women's health including reproductive, obstetric, and gynecological conditions.",
      "image": "https://mamshospitals.com/images/12 Dr Mallu Srinija.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Ammula Syamala",
      "medicalSpecialty": "Gynacology",
      "description": "Expert care for women's health including reproductive, obstetric, and gynecological conditions.",
      "image": "https://mamshospitals.com/images/13 Dr Ammula Syamala.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    //Radiology
    {
      "@type": "Physician",
      "name": "Dr Sudha Bindu",
      "medicalSpecialty": "Radiology",
      "description": "Radiology uses medical imaging to diagnose and monitor diseases and conditions.",
      "image": "https://mamshospitals.com/Dr Sudha Bindu.png",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Anvitha",
      "medicalSpecialty": "Radiology",
      "description": "Radiology uses medical imaging to diagnose and monitor diseases and conditions.",
      "image": "https://mamshospitals.com/Dr. Anvitha.png",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Geethika",
      "medicalSpecialty": "Radiology",
      "description": "Radiology uses medical imaging to diagnose and monitor diseases and conditions.",
      "image": "https://mamshospitals.com/Dr. Geethika.png",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Manisha",
      "medicalSpecialty": "Radiology",
      "description": "Radiology uses medical imaging to diagnose and monitor diseases and conditions.",
      "image": "https://mamshospitals.com/Dr. Manisha.png",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr MS Saif",
      "medicalSpecialty": "Radiology",
      "description": "Radiology uses medical imaging to diagnose and monitor diseases and conditions.",
      "image": "https://mamshospitals.com/Dr. MS Saif.png",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Pranav Sreenath",
      "medicalSpecialty": "Radiology",
      "description": "Radiology uses medical imaging to diagnose and monitor diseases and conditions.",
      "image": "https://mamshospitals.com/Dr. Pranav Sreenath.png",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Ramsubhash",
      "medicalSpecialty": "Radiology",
      "description": "Radiology uses medical imaging to diagnose and monitor diseases and conditions.",
      "image": "https://mamshospitals.com/Dr. Ramsubhash A.png",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Ritesh Kumar",
      "medicalSpecialty": "Radiology",
      "description": "Radiology uses medical imaging to diagnose and monitor diseases and conditions.",
      "image": "https://mamshospitals.com/Dr. Ritesh Kumar.png",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Roopesh",
      "medicalSpecialty": "Radiology",
      "description": "Radiology uses medical imaging to diagnose and monitor diseases and conditions.",
      "image": "https://mamshospitals.com/Dr. Roopesh.png",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Vaishnavi",
      "medicalSpecialty": "Radiology",
      "description": "Radiology uses medical imaging to diagnose and monitor diseases and conditions.",
      "image": "https://mamshospitals.com/Dr. vaishnavi.png",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    //Physiotherapy
    {
      "@type": "Physician",
      "name": "Dr Venkat",
      "medicalSpecialty": "Physiotherapy",
      "description": "Physiotherapy helps restore movement, strength, and function through targeted exercises and treatments.",
      "image": "https://mamshospitals.com/jpeg-optimizer_1.Dr .Venkat.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Kadiraiah",
      "medicalSpecialty": "Physiotherapy",
      "description": "Physiotherapy helps restore movement, strength, and function through targeted exercises and treatments.",
      "image": "https://mamshospitals.com/jpeg-optimizer_2.Dr.Kadiraiah.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Mohammed Omer",
      "medicalSpecialty": "Physiotherapy",
      "description": "Physiotherapy helps restore movement, strength, and function through targeted exercises and treatments.",
      "image": "https://mamshospitals.com/jpeg-optimizer_3.Dr.Mohammed Omer.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Anurag",
      "medicalSpecialty": "Physiotherapy",
      "description": "Physiotherapy helps restore movement, strength, and function through targeted exercises and treatments.",
      "image": "https://mamshospitals.com/jpeg-optimizer_4.Dr.Anurag.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Pratyusha",
      "medicalSpecialty": "Physiotherapy",
      "description": "Physiotherapy helps restore movement, strength, and function through targeted exercises and treatments.",
      "image": "https://mamshospitals.com/jpeg-optimizer_Dr .Pratyusha.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    //Urology
    {
      "@type": "Physician",
      "name": "Dr Ram Murthy",
      "medicalSpecialty": "Urology",
      "description": "Urology focuses on the diagnosis and treatment of urinary tract and male reproductive system conditions.",
      "image": "https://mamshospitals.com//Dr.-ram-murthy.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    {
      "@type": "Physician",
      "name": "Dr Balram",
      "medicalSpecialty": "Urology",
      "description": "Urology focuses on the diagnosis and treatment of urinary tract and male reproductive system conditions.",
      "image": "https://mamshospitals.com//Dr-balram.jpg",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    //Cardiology
    {
      "@type": "Physician",
      "name": "Dr Sambasiva Rao",
      "medicalSpecialty": "Cardiology",
      "description": "Expert in interventional cardiology with over 15 years of experience in treating complex heart conditions.",
      "image": "https://mamshospitals.com/images/DR.SAMBASIVA RAO.JPG",
      "memberOf": { "@type": "Hospital", "name": "MAMS Hospitals" }
    },
    

  ]
}

  
  
  }
];


const Doctors = () => {
  const [selectedSpecialty, setSelectedSpecialty] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  
const [doctors, setDoctors] = useState([]);
const [loading, setLoading] = useState(true);
useEffect(() => {
  Promise.all([
    fetch(
      "https://mamshospitals.mamscollege.com/wp-json/wp/v2/doctor?_embed&per_page=100&page=1"
    ).then((res) => res.json()),

    fetch(
      "https://mamshospitals.mamscollege.com/wp-json/wp/v2/doctor?_embed&per_page=100&page=2"
    ).then((res) => res.json()),
  ])

    .then(([page1, page2]) => {
  const allDoctors = [...page1, ...page2];

  const designationOrder = {
    "HOD": 1,
    "Professor & HOD": 2,
    "Professor": 3,
    "Associate Professor": 4,
    "Assistant Professor": 5,
    "Senior Consultant": 6,
    "Consultant": 7,
    "Senior Resident": 8,
    "Resident": 9,
  };

  console.log("Doctor Designations");

allDoctors.forEach((doctor) => {
  console.log(
    doctor.title.rendered,
    "=>",
    `"${doctor.acf?.designation}"`
  );
});

  allDoctors.sort((a, b) => {
    const orderA = designationOrder[a.acf?.designation] || 999;
    const orderB = designationOrder[b.acf?.designation] || 999;

    if (orderA !== orderB) {
      return orderA - orderB;
    }

    return a.title.rendered.localeCompare(b.title.rendered);
  });

  setDoctors(allDoctors);
  setLoading(false);
})

    .catch((err) => {
      console.error(err);
      setLoading(false);
    });
}, []);

const allSpecialties = [
  ...new Set(
    doctors.map(
      (doctor) =>
        doctor._embedded?.["wp:term"]?.[0]?.[0]?.name || "General"
    )
  ),
];

  // Apply filters synchronously during render
    const filteredDoctors = useMemo(() => {
      let result = doctors;

      if (selectedSpecialty !== "all") {
        result = result.filter(
          (doctor) =>
            (doctor._embedded?.["wp:term"]?.[0]?.[0]?.name || "General") ===
            selectedSpecialty
        );
      }

      if (searchQuery) {
        const query = searchQuery.toLowerCase();

        result = result.filter((doctor) =>
          doctor.title.rendered.toLowerCase().includes(query)
        );
      }

      return result;
    }, [doctors, selectedSpecialty, searchQuery]);

  // Handle specialty change
  const handleSpecialtyChange = (value) => {
    setSelectedSpecialty(value)
  }

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value)
  }

  // Toggle filter panel on mobile
  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen)
  }

  return (
    <>
      <SEO
        title="MAMS Hospital Doctors & Consultants – Expert Medical Team in Hyderabad"
        description="Meet the expert medical team at MAMS Hospital, Bachupally — skilled consultants in General Surgery, Orthopaedics, ENT, Paediatrics and more delivering quality patient care & teaching."
        keywords="Hyderabad's Best Multispecialty Hospital, Best Hospital near Bachupally Hyderabad, Best Hospital near Miyapur Hyderabad, Best Hospital near Nizampet, Multispecialty Hospital near KPHB Colony, Emergency Hospital near JNTU Hyderabad, 24-hour Hospital in Bachupally Hyderabad, Emergency Care Hospital in Hyderabad, Best Cardiology Hospital in Hyderabad, Best Neurology Hospital Hyderabad, Orthopaedics Hospital in Bachupally Hyderabad, Best Joint Replacement Hospital Hyderabad, Spine Surgery Specialist Hyderabad, Best ENT Hospital in Hyderabad, Best Gynecology Hospital Hyderabad, Maternity & Child Care Hospital Hyderabad, Best Pediatric Hospital in Bachupally, Neonatal ICU Hospital Hyderabad, General Medicine Specialist Hyderabad, Best General Surgery Hospital Hyderabad, Critical Care Hospital near Miyapur Hyderabad, Best Physiotherapy Hospital Hyderabad, Mamata Academy of Medical Sciences hospital,Dr. Behara Srinivas general surgery MAMS Hospital, Dr Karumuru Kiran Kumar orthopaedics, Dr Kavya Sivapuram ENT specialist Hyderabad, MAMS Hospital consultants list, Mamata Academy medical college doctors Hyderabad"
        schema={schema}
      canonicalUrl="https://mamshospitals.com/doctors"
      />

    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="bg-primary/5 py-12 md:py-12">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-semibold text-gray-800 mb-6">Meet Our Doctors</h1>
            <p className="text-lg text-gray-600">
              Our team of highly qualified healthcare professionals is committed to providing exceptional care with
              expertise and compassion.
            </p>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-8 px-4 border-b border-gray-200">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
         

            <div className="flex items-center gap-2 w-full md:w-auto">
              <button
                className="md:hidden flex items-center gap-2 border border-gray-300 rounded-full px-4 py-2 hover:bg-primary/5"
                onClick={toggleFilter}
              >
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.707A1 1 0 013 7V4z"
                  />
                </svg>
                Filter
              </button>

              <div className={`${isFilterOpen ? "block" : "hidden"} md:block w-full md:w-auto`}>
                <select
                  value={selectedSpecialty}
                  onChange={(e) => handleSpecialtyChange(e.target.value)}
                  className="w-full md:w-[200px] rounded-full border border-gray-300 focus:ring-teal-600 px-4 py-2 focus:outline-none"
                >
                  <option value="all">All Specialties</option>
                  {allSpecialties.map((specialty) => (
                    <option key={specialty} value={specialty}>
                      {specialty}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Grid */}
      <section className="py-8 md:py-16 px-0 md:px-4">
        <div className="container mx-auto max-w-6xl">
          <h2 className="text-2xl font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">
            {selectedSpecialty !== "all" ? selectedSpecialty : searchQuery ? "Search Results" : "All Doctors"}
            {filteredDoctors.length > 0 && (
              <span className="text-gray-600 text-lg font-normal ml-2">
                ({filteredDoctors.length} {filteredDoctors.length === 1 ? "doctor" : "doctors"})
              </span>
            )}
          </h2>
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[...Array(6)].map((_, index) => (
                <div
                  key={index}
                  className="h-[420px] rounded-lg bg-gray-200 animate-pulse"
                />
              ))}
            </div>
          ) : filteredDoctors.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredDoctors.map((doctor) => (
                <DoctorCard
                  key={doctor.id}
                  doctor={{
                    name: doctor.title.rendered,
                    slug: doctor.slug,
                    imageUrl:
                      doctor._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "",
                    specialty:
                      doctor._embedded?.["wp:term"]?.[0]?.[0]?.name || "",

                    designation: doctor.acf?.designation || "",
                    qualification: doctor.acf?.qualification || "",
                    experience: doctor.acf?.experience || "",
                  }}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="text-gray-600 mb-4">
                No doctors found matching your criteria.
              </p>
              <button
                onClick={() => {
                  setSelectedSpecialty("all");
                  setSearchQuery("");
                }}
                className="bg-gray-100 text-gray-800 px-6 py-3 rounded-full font-medium hover:bg-gray-200 transition-colors"
              >
                Clear Filters
              </button>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-8 md:py-16 px-0 md:px-4 bg-primary/5">
        <div className="container mx-auto max-w-6xl">
          <div className="bg-[#096256] text-white rounded-lg p-8 md:p-12 shadow-lg">
            <div className="text-center max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-semibold mb-4">Need a Medical Consultation?</h2>
              <p className="text-white/90 mb-8">
                Schedule an appointment with our specialists and take the first step towards better health. 
              </p>
              {/* <Link to="/contact">
                <button className="bg-white text-teal-600 px-8 py-3 rounded-full font-medium hover:bg-gray-100 transition-colors">
                  Contact Us
                </button>
              </Link> */}
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  )
}

export default Doctors;
